$(document).one('turbo:load', function () {
	if (!$('.shared-inbox-controller').length) return;
	if (window.sharedInboxInitialized) return;
	window.sharedInboxInitialized = true;
	// Search for contacts in list.
	$('#search_contacts').keyup(function () {
		var term = $(this).val().toLowerCase();

		if (term.length === 0) {
			$('.chat_list_tab').show();
		} else {
			$('.chat_list_tab').hide();
			$('.chat_list_tab[data-searchable*="' + term + '"]').show();
		}
	});

	$('#chat-back-btn').click(function (event) {
		$('.chat_list_tab').removeClass('active');
	});

	$('#chat-back-btn, .chat_list_tab').click(function (event) {
		$('#chat_list_sidebar').toggleClass('show-for-small-up');
		$('#chat_window').toggleClass('show-for-small-up');
		$('#chat_box_input').val('');
	});

	bindChatListTab($('.chat_list_tab'));

	// Need timeout because will need every element to properly load. Also the scrolldown animation will look better.
	setTimeout(openFirstChatWindow(), 500);
});

// Loads chat window for this contact.
function bindChatListTab(tabs) {
	tabs.click(function () {
		list_tab = $(this);
		chat_id = list_tab.attr('data-chat-id');
		first_id = list_tab.data('first-message');
		url = 'inbox/' + chat_id + '/load_chat_window';
		check_id = $('#chat_box_input').attr('data-group-id');
		clearUnviewedMessages(list_tab);

		if (chat_id === check_id || $('#chat_window_input').attr('data-loading-window') === 'true') {
			return false;
		}

		showWindowLoader();
		setTimeout(ajaxCallToSwitchChatWindow(url, list_tab, chat_id, first_id), 100);
	});
}

function ajaxCallToSwitchChatWindow(url, list_tab, chat_id, first_id) {
	$.ajax({
		url: url,
		type: 'POST',
		async: true
	})
		.done(function (response) {
			if (response.logged_out) {
				popupAlert('Cannot load messages. You have been logged out. Please login and try again');
			} else {
				$('.chat_list_tab').removeClass('active');
				list_tab.addClass('active');
				$('#chat-info').find('img').attr('src', list_tab.find('img').attr('src'));
				$('#chat-name').text(list_tab.find('.group-chat-name').text());
				$('#chat_window_container').html(response);
				$('#chat_box_input').attr('data-group-id', chat_id);
				seenMessageUpdate();
				$('#chat_box_input').attr('data-oldest-message-id', first_id);
				$('#chat_box_input').attr('data-disable-old-message-load', 'true');
				setTimeout(resetOldMessageLoadState, 500);
				hideWindowLoader();
				scrollToBottom();
			}
		}).fail(function () {
			popupAlert('An error has occured. Could not load messages.');
		});
}

function showWindowLoader() {
	$('#chat_window_loader').removeClass('hidden');
	$('#chat_window_container').addClass('hidden');
	$('#chat_window_input').attr('data-loading-window', true);
}

function hideWindowLoader() {
	$('#chat_window_loader').addClass('hidden');
	$('#chat_window_container').removeClass('hidden');
	$('#chat_window_input').attr('data-loading-window', false);
}

function resetOldMessageLoadState() {
	$('#chat_box_input').attr('data-disable-old-message-load', 'false');
}

function clearUnviewedMessages(tab) {
	$(tab).find('.new_messages_alert').fadeOut();
	$(tab).find('.message_holder').removeClass('font-weight-bold');
}

function scrollToBottom() {
	$('#chat_window_container').animate({ scrollTop: $('#chat_window_container').prop('scrollHeight') }, 100);
}

// Mark messages as seen.
function seenMessageUpdate() {
	chat_id = $('#chat_box_input').attr('data-group-id');

	if (chat_id.includes('new:')) {
		return false
	}

	seen_url = '/inbox/' + chat_id + '/seen_messages';

	$.ajax({
		url: seen_url,
		type: 'POST'
	});
}

function openFirstChatWindow() {
	windows = $('.chat_list_tab');
	target = $('#chat_list_sidebar').data('target-window');

	if (windows.length > 0 && ($(window).width() >= 1024 || target !== '')) {
		if (target === '') {
			$(windows.first()).click();
		} else {
			tab = $('.chat_list_tab[data-chat-id="' + target + '"]');
			tab.click();
			$('#chat_list_contacts').scrollTop(tab.offset().top - 134);
			// 134 is the height of the chat window tab.
		}
	}
}